export default async function timedFetch<T>(
  label: string,
  fn: () => Promise<T>,
): Promise<T> {
  const start = performance.now();

  try {
    const result = await fn();

    if (process.env.SSR_TIMING === '1') {
      console.info(
        `[SSR] ${label}: ${(performance.now() - start).toFixed(0)}ms ok`,
      );
    }

    return result;
  } catch (error) {
    if (process.env.SSR_TIMING === '1') {
      console.info(
        `[SSR] ${label}: ${(performance.now() - start).toFixed(0)}ms failed`,
      );
    }

    throw error;
  }
}
